import $ from '../../offline/jquery.min.js';

class FormErrors {
  static goToError = () => {
    if ($('#react-form').length > 0) {
      setTimeout( () => {
        let element = $('.WrapperDynamicForm_Columns .InputWrapper_Error');
        if (element.length === 0)
          element = $('.WrapperDynamicForm_Columns .InputWrapper-Error:visible');
        if (element.length !== 0) {
          let top = $(element[0]).offset().top - 60 - $('.WrapperDynamicForm_Columns').offset().top;
          let top_content = $('.WrapperDynamicForm_Columns').scrollTop();
          $('.WrapperDynamicForm_Columns').animate({scrollTop: top + top_content}, 'fast');
        }
      }, 50);
    }
    else if ($('.WrapperWidget_Form').length > 0) {
      setTimeout( () => {
        let element = $('.WrapperWidget_Form .InputWrapper_Error');
        if (element.length === 0)
          element = $('.WrapperWidget_Form .InputWrapper-Error:visible');
        if (element.length !== 0) {
          let top = $(element[0]).offset().top - 40 - $('body .WrapperWidget_Form .WrapperWidget_Form_Content').offset().top;
          let top_content = $('body .WrapperWidget_Form .WrapperWidget_Form_Content').scrollTop();
          $('body .WrapperWidget_Form .WrapperWidget_Form_Content').animate({scrollTop: top + top_content}, 'fast');
        }
      }, 50);
    }
    else if ($('.ngdialog').length > 0) {
      setTimeout( () => {
        let element = $('.ngdialog .InputWrapper_Error');
        if (element.length === 0)
          element = $('.ngdialog .InputWrapper-Error:visible');
        if (element.length !== 0) {
          let top = $(element[0]).offset().top - 80;
          let top_content = $('body .ngdialog .ngdialog-content').scrollTop();
          $('body .ngdialog .ngdialog-content').animate({scrollTop: top + top_content}, 'fast');
        }
      }, 50);
    }
    else {
      setTimeout( () => {
        let element = $('.InputWrapper_Error');
        if (element.length === 0)
          element = $('.InputWrapper-Error:visible');
        if (element.length !== 0) {
          let top = $(element[0]).offset().top - 220;
          let top_content = $('.wrapper-columns-column.region-main .content-column').scrollTop();
          $('.wrapper-columns-column.region-main .content-column').animate({scrollTop: top + top_content}, 'fast');
        }
      }, 50);
    }
  };
}

export default FormErrors;